import React, { Component } from "react";
import "../../Issues/IssuesModal.css";

// UI Components
import Tabs from "../../../../components/Tabs/Tabs";
import ajaxMethods from "../../../../api/ajax-methods";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";

//Table Helper Controllers
import {
  mifosRepaymentColumn,
  reOrderTableData,
} from "./../../../../redux/actions/loans";
// import Dropzone from 'react-dropzone';
import { MDBDataTable } from "mdbreact";
import { formatMifosDate } from "../../../../helpers/formatMifosDate";
import { appInsights } from "../../../../config/appInsights";

export default class ViewMifosLoans extends Component {
  state = {
    scene: "form",
    formScene: "loan_details",
    tabs: [
      {
        name: "Loan Details",
        id: "loan_details",
        icon: "far fa-building",
        identifier: "mifoInfoTab",
      },
      {
        name: "Repayment Schedule",
        id: "loan_schedule",
        icon: "fas fa-chart-bar",
        identifier: "mifoInfoTab",
      },
    ],
    mifosDetails: [],
    mifosAmountDetails: [],
    mifosRepaymentSchedule: [],
    loanDates: [],
    error: false,
    loader: false,
  };

  componentDidMount = () => {
    this.getMifosDetails();
  };

  getMifosDetails = () => {
    this.setState({ loader: true });
    ajaxMethods
      .get(
        ajaxEndpoints.GET_MIFOS_LOAN_DETAILS +
          "?externalId=" +
          this.props.dataRecord.loan_ref
      )
      // ajaxMethods
      //   .get(ajaxEndpoints.GET_MIFOS_LOAN_DETAILS + "?externalId=ref_0009")
      .then((response) => {
        this.setState({ loader: false });
        let res = response.data.responseData;

        if (res) {
          this.setState({
            mifosDetails: res,
            mifosAmountDetails: res.summary,
            loanDates: res.timeline,
            mifosRepaymentSchedule: res.repaymentSchedule.periods,
          });
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "ViewMifosLoans.js",
          },
        });
        this.setState({ error: true });
      });
  };

  printHandler = () => {};

  cancelHandler = () => {};

  // Toggle Tab & Tab content for Data Table
  toggleTabContent = (content) => {
    this.setState({
      formScene: content,
    });
  };

  render() {
    const {
      scene,
      tabs,
      formScene,
      mifosDetails,
      mifosAmountDetails,
      loanDates,
      loader,
      mifosRepaymentSchedule,
      error,
    } = this.state;

    const dataRecord = this.props.dataRecord;

    const { borrower_id } = dataRecord;

    return (
      <div
        className="Modal__dialog lg-modal animated slideInDown"
        role="document"
      >
        <div
          className="IssueModal Modal__content"
          style={{ overflow: "hidden" }}
        >
          <div className="Modal__body">
            <h3 className="Modal__title p-b-2">
              Borrower id: <span>{borrower_id}</span>
            </h3>
            {(() => {
              switch (scene) {
                case "form":
                  return (
                    <form>
                      <div className="row m-b-1">
                        <Tabs
                          onContentToggle={this.toggleTabContent}
                          tabs={tabs}
                        />
                      </div>
                      {(() => {
                        switch (formScene) {
                          case "loan_details":
                            return (
                              <LoanDetails
                                details={mifosDetails}
                                mifosAmountDetails={mifosAmountDetails}
                                loanDates={loanDates}
                                loader={loader}
                              />
                            );

                          case "loan_schedule":
                            return (
                              <LoanSchedule
                                mifosRepayment={mifosRepaymentSchedule}
                                error={error}
                                loader={loader}
                              />
                            );
                          default:
                            return null;
                        }
                      })()}
                    </form>
                  );

                case "loader":
                  return (
                    <div>
                      {/* 2. login Form Loader */}
                      <div
                        id="adv-login-loader"
                        className="loading-overlay speed-1x fadeInRight"
                      >
                        <div className="form-loader form-loader-login verify">
                          <div className="centerLoader">
                            <div className="loading" id="adv-loader-alt" />
                            <div className="center-txt webapp-ripple-text">
                              <i className="notifier fas fa-user-circle" />
                              &nbsp; Processing your Details
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );

                case "success":
                  return (
                    <div>
                      {/* 3. Login Response */}
                      <div
                        id="adv-login-response"
                        className="loading-overlay speed-1x fadeInRight"
                      >
                        <div className="form-loader form-loader-login verify">
                          <div className="centerLoader">
                            <div className="loading success-loader">
                              <i className="webapp-ripple-notification success-text fa fa-check-circle" />
                            </div>
                            <div className="center-txt webapp-ripple-text">
                              Logged In Successfully
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );

                case "fail":
                  return (
                    <div>
                      {/* 3. Login Response */}
                      <div
                        id="adv-login-response"
                        className="loading-overlay speed-1x fadeInRight"
                      >
                        <div className="form-loader form-loader-login verify">
                          <div className="centerLoader">
                            <div className="loading success-loader">
                              <i className="webapp-ripple-notification success-text fa fa-close-circle" />
                            </div>
                            <div className="center-txt webapp-ripple-text">
                              Login Failed, try again later
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );

                default:
                  return null;
              }
            })()}

            <div className="Form__action-buttons">
              {/* <button type="button"
                                className="btn zoom-element btn login-btn m-0 mr-auto"
                                onClick={this.proceedHandler}>Print</button> */}
              <button
                type="button"
                className="btn zoom-element btn login-btn"
                onClick={this.props.onCloseModal}
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// Loan Details
const LoanDetails = (props) => {
  const { details, loanDates } = props;
  return (
    // <div className="m-b-2">
    <React.Fragment>
      {props.loader && (
        <div
          id="adv-login-loader"
          className="loading-overlay speed-1x fadeInRight"
        >
          <div className="form-loader form-loader-login verify">
            <div className="centerLoader">
              <div className="loading" id="adv-loader-alt" />
              <div className="center-txt webapp-ripple-text">
                <i className="notifier fas fa-user-circle" />
                &nbsp; Loading mifos Details
              </div>
            </div>
          </div>
        </div>
      )}
      {!props.loader && (
        <div>
          <div className="row">
            <div className="col-xs-4">
              <label className="label-txt">Business Name</label>
              <div className="form-group inputWithIcon">
                <input
                  type="text"
                  className="user__form form-control"
                  readOnly
                  value={
                    !props.loader ? props?.details?.clientName || "n/a" : ""
                  }
                />
                <i className="far fa-calendar-alt" />
              </div>
            </div>
            <div className="col-xs-4">
              <label className="label-txt">Product Name</label>
              <div className="form-group inputWithIcon">
                <input
                  type="text"
                  readOnly
                  name="cardNumber"
                  className="user__form form-control"
                  value={
                    !props.loader
                      ? props?.details?.loanProductName || "n/a"
                      : ""
                  }
                />
                <i className="far fa-credit-card" />
              </div>
            </div>
            <div className="col-xs-4">
              <label className="label-txt">Interest (% per annum)</label>
              <div className="form-group inputWithIcon">
                <input
                  type="text"
                  className="user__form form-control"
                  readOnly
                  value={
                    !props.loader
                      ? props?.details?.annualInterestRate || "n/a"
                      : ""
                  }
                />
                <i className="far fa-calendar-alt" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-4">
              <label className="label-txt">Loan Amount (Principal)</label>
              <div className="form-group inputWithIcon">
                <input
                  type="text"
                  className="user__form form-control"
                  readOnly
                  value={
                    !props.loader
                      ? props?.mifosAmountDetails?.principalDisbursed || "n/a"
                      : ""
                  }
                />
                <i className="far fa-calendar-alt" />
              </div>
            </div>
            <div className="col-xs-4">
              <label className="label-txt">Interest Amount</label>
              <div className="form-group inputWithIcon">
                <input
                  type="text"
                  readOnly
                  className="user__form form-control"
                  value={
                    !props.loader
                      ? props?.mifosAmountDetails?.interestCharged || "n/a"
                      : ""
                  }
                />
                <i className="fas fa-user-circle" />
              </div>
            </div>
            <div className="col-xs-4">
              <label className="label-txt">Loan Repay Amount</label>
              <div className="form-group inputWithIcon">
                <input
                  type="text"
                  readOnly
                  className="user__form form-control"
                  value={
                    !props.loader
                      ? props?.mifosAmountDetails?.totalExpectedRepayment ||
                        "n/a"
                      : ""
                  }
                />
                <i className="fas fa-user-circle" />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-4">
              <label className="label-txt">Outstanding Principal</label>
              <div className="form-group inputWithIcon">
                <input
                  type="text"
                  className="user__form form-control"
                  readOnly
                  value={
                    !props.loader
                      ? props?.mifosAmountDetails?.principalOutstanding || "n/a"
                      : ""
                  }
                />
                <i className="far fa-calendar-alt" />
              </div>
            </div>
            <div className="col-xs-4">
              <label className="label-txt">Outstanding Interest</label>
              <div className="form-group inputWithIcon">
                <input
                  type="text"
                  readOnly
                  className="user__form form-control"
                  value={
                    !props.loader
                      ? props?.mifosAmountDetails?.interestOutstanding || "n/a"
                      : ""
                  }
                />
                <i className="fas fa-user-circle" />
              </div>
            </div>
            <div className="col-xs-4">
              <label className="label-txt">Current Debt</label>
              <div className="form-group inputWithIcon">
                <input
                  type="text"
                  className="user__form form-control"
                  readOnly
                  value={
                    !props.loader
                      ? props?.mifosAmountDetails?.totalOutstanding || "n/a"
                      : ""
                  }
                />
                <i className="far fa-calendar-alt" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-4">
              <label className="label-txt">Loan Tenure</label>
              <div className="form-group inputWithIcon">
                <input
                  type="text"
                  readOnly
                  className="user__form form-control"
                  value={
                    !props.loader ? props?.details?.termFrequency || "n/a" : ""
                  }
                />
                <i className="fas fa-user-circle" />
              </div>
            </div>

            <div className="col-xs-4">
              <label className="label-txt">Repayment Frequency </label>
              <div className="form-group inputWithIcon">
                <input
                  type="text"
                  className="user__form form-control"
                  readOnly
                  value={details?.termPeriodFrequencyType?.value || "n/a"}
                />
                <i className="far fa-calendar-alt" />
              </div>
            </div>
            <div className="col-xs-4">
              <label className="label-txt">Schedule Type</label>
              <div className="form-group inputWithIcon">
                <input
                  type="text"
                  readOnly
                  className="user__form form-control"
                  value={details?.interestType?.value || "n/a"}
                />
                <i className="fas fa-user-circle" />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-4">
              <label className="label-txt">Disbursed Date</label>
              <div className="form-group inputWithIcon">
                <input
                  type="text"
                  className="user__form form-control"
                  readOnly
                  value={
                    !props.loader
                      ? formatMifosDate(props?.loanDates?.approvedOnDate) ||
                        "n/a"
                      : ""
                  }
                />
                <i className="fas fa-user-circle" />
              </div>
            </div>
            <div className="col-xs-4">
              <label className="label-txt">Expected Maturity Date</label>
              <div className="form-group inputWithIcon">
                <input
                  type="text"
                  readOnly
                  name="cardNumber"
                  className="user__form form-control"
                  value={
                    formatMifosDate(loanDates?.expectedMaturityDate) || "n/a"
                  }
                />
                <i className="far fa-calendar-alt" />
              </div>
            </div>
            <div className="col-xs-4">
              <label className="label-txt">Status</label>
              <div className="form-group inputWithIcon">
                <input
                  type="text"
                  readOnly
                  className="user__form form-control"
                  value={
                    !props.loader
                      ? props.details?.status?.active === true
                        ? "ACTIVE"
                        : props.details?.status?.pendingApproval === true
                        ? "Pending"
                        : props.details?.status?.pendingApproval &&
                          props.details?.status?.active !== true
                        ? "Denied"
                        : "n/a"
                      : ""
                  }
                />
                <i className="fas fa-user-circle" />
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};
// Aggregator Details
const LoanSchedule = (props) => {
  const { mifosRepayment, error, loader } = props;

  let RenderedComponent = null;
  if (error || mifosRepayment === undefined) {
    RenderedComponent = (
      <div className="animated fadeInRight">
        <h4 className="p-y-5 text-center">
          <i className="fas fa-bell" /> Unable to Fetch mifos details
        </h4>
      </div>
    );
  } else if (mifosRepayment === null || loader) {
    RenderedComponent = (
      <div
        id="adv-login-loader"
        className="loading-overlay speed-1x fadeInRight"
      >
        <div className="form-loader form-loader-login verify">
          <div className="centerLoader">
            <div className="loading" id="adv-loader-alt" />
            <div className="center-txt webapp-ripple-text">
              <i className="notifier fas fa-user-circle" />
              &nbsp; Loading mifos Details
            </div>
          </div>
        </div>
      </div>
    );
  } else if (mifosRepayment.length) {
    // Verify that a loans object exists
    if (mifosRepayment.length === 0) {
      RenderedComponent = (
        <div className="centerLoader">
          <div className="tfx-user-form-wrapper box-effect full-border white-bg animated fadeInRight">
            <h4 className="p-y-5 text-center">
              <i className="fas fa-bell" /> There are currently no mifos
              repayment details
            </h4>
          </div>
        </div>
      );
    } else {
      const mifosAmountDetails = reOrderTableData(
        mifosRepaymentColumn,
        mifosRepayment
      );

      RenderedComponent = (
        <div>
          <MDBDataTable
            responsive
            minimal="true"
            striped
            bordered
            hover
            data={mifosAmountDetails}
          />
        </div>
      );
    }
  }
  return (
    <React.Fragment>
      <div>{RenderedComponent}</div>
    </React.Fragment>
  );
};
